export const navItems = [
  { id: "channels", label: "资源渠道" },
  { id: "detail", label: "渠道详解" },
  { id: "query", label: "查询步骤" },
  { id: "tools", label: "工具对比" },
  { id: "safety", label: "安全提示" },
  { id: "faq", label: "常见问题" },
  { id: "updates", label: "动态更新" },
];

export const tickerItems = [
  "本页仅整理「善良的女秘书」相关搜索渠道的通用查询思路与注意事项，不提供、不托管任何受版权保护的影片文件。",
  "使用任何网盘或下载工具前，请先确认资源来源合法，并遵守所在地区法律法规与平台用户协议。",
  "网盘分享链接可能随时失效，遇到打不开属于正常现象，建议以关键词重新检索。",
  "下载压缩包后先查毒再解压，不含广告与捆绑程序的播放文件更适合长期收藏。",
];

export const quickStats = [
  { value: "6", label: "主流查询渠道" },
  { value: "4", label: "标准查询步骤" },
  { value: "8", label: "常见疑问解答" },
  { value: "4", label: "工具对比维度" },
];

export const channels = [
  {
    id: "baidu",
    name: "百度云",
    icon: "ri-cloud-line",
    tag: "网盘分享",
    summary:
      "国内最常被提及的网盘入口之一，很多「善良的女秘书」相关资源以分享链接形式存在，适合习惯用网盘在线观看或转存的用户。",
    highlights: ["分享链接形式常见", "支持在线预览与转存", "可跨设备继续观看"],
    bestFor: "偏好网盘在线观看、想要一键转存到个人空间的用户",
  },
  {
    id: "pan",
    name: "网盘资源",
    icon: "ri-folders-line",
    tag: "聚合检索",
    summary:
      "泛指各类网盘分享站与资源聚合页。它们把百度云、阿里云盘等分散的分享链接集中展示，便于按标题关键词一次性浏览。",
    highlights: ["聚合多个网盘入口", "按标题关键词浏览", "更新频率差异较大"],
    bestFor: "还不确定资源在哪个网盘、想先横向比较的用户",
  },
  {
    id: "thunder",
    name: "迅雷下载",
    icon: "ri-download-cloud-2-line",
    tag: "下载工具",
    summary:
      "以加速下载见长的下载工具，常与磁力链接、种子文件配合使用，对老资源与冷门文件的连接能力相对更强。",
    highlights: ["支持多种链接协议", "支持边下边播", "对冷门资源有补速能力"],
    bestFor: "网络环境一般、希望提升下载稳定性的用户",
  },
  {
    id: "magnet",
    name: "磁力链接",
    icon: "ri-links-line",
    tag: "链接协议",
    summary:
      "以磁力链接（magnet）形式分发的资源，通过内容哈希定位文件，不依赖中心服务器，是种子资源常见的分享方式。",
    highlights: ["无需中心服务器", "分享方只需一串链接", "需要支持的客户端打开"],
    bestFor: "熟悉 BT 生态、愿意自行选择客户端的用户",
  },
  {
    id: "torrent",
    name: "种子资源",
    icon: "ri-file-list-3-line",
    tag: "文件种子",
    summary:
      "扩展名为 .torrent 的种子文件，记录了资源的分块信息与节点地址。它与磁力链接同属一类分发体系，常互相转换使用。",
    highlights: ["结构信息完整", "可校验文件完整性", "依赖做种节点"],
    bestFor: "希望自行控制下载内容与完整性的用户",
  },
  {
    id: "aliyun",
    name: "阿里云盘",
    icon: "ri-hard-drive-3-line",
    tag: "云盘分享",
    summary:
      "近年常见的另一类网盘入口，部分分享者会把资源转存到阿里云盘再发布，适合关注传输速度与在线播放体验的用户。",
    highlights: ["传输速度体验较好", "支持在线播放", "分享规则随平台调整"],
    bestFor: "更看重传输速度与在线播放流畅度的用户",
  },
];

export const channelDetails = [
  {
    id: "baidu",
    name: "百度云",
    icon: "ri-cloud-line",
    usage: "把搜索到的分享链接保存到自己的网盘空间，再选择在线播放或下载到本地。",
    pros: ["资源覆盖面广，标题命中率高", "转存操作简单，适合长期整理", "多端同步，手机与电脑都能看"],
    cons: ["非会员下载速度可能受限", "分享链接失效较为常见", "部分文件需要客户端才能打开"],
    formats: "在线视频流、.mp4 / .mkv 离线文件、压缩包 .zip / .rar",
  },
  {
    id: "pan",
    name: "网盘资源",
    icon: "ri-folders-line",
    usage: "在聚合页按标题关键词检索，先浏览条目列表，再决定进入哪一个网盘查看详情。",
    pros: ["一个页面看到多个网盘入口", "通常带有更新时间与大小标注", "便于比较不同来源"],
    cons: ["站点质量参差不齐，需自行甄别", "广告与跳转较多", "链接有效性无法完全保证"],
    formats: "以分享链接为主，附带标题、大小、更新时间等文字信息",
  },
  {
    id: "thunder",
    name: "迅雷下载",
    icon: "ri-download-cloud-2-line",
    usage: "把磁力链接或种子文件交给迅雷，由它负责连接节点、加速下载与任务管理。",
    pros: ["对老资源的连接能力较强", "支持离线空间与边下边播", "任务队列管理较直观"],
    cons: ["部分功能需要会员", "安装时注意取消捆绑选项", "速度受网络与资源热度影响"],
    formats: "magnet 磁力链接、.torrent 种子文件、thunder:// 专用链接",
  },
  {
    id: "magnet",
    name: "磁力链接",
    icon: "ri-links-line",
    usage: "复制以 magnet:? 开头的一整段链接，粘贴进任意支持磁力的客户端即可开始解析。",
    pros: ["分享与传播成本极低", "不依赖单一服务器", "一行文本即可完整携带信息"],
    cons: ["需要自行选择可信客户端", "解析速度受节点数量影响", "无法直观看到文件列表"],
    formats: "magnet:?xt=urn:btih:... 形式的纯文本链接",
  },
  {
    id: "torrent",
    name: "种子资源",
    icon: "ri-file-list-3-line",
    usage: "下载 .torrent 文件后，用 BT 客户端打开并选择需要的内容开始下载。",
    pros: ["包含完整的分块与校验信息", "可选择性下载其中部分文件", "便于归档与二次分享"],
    cons: ["依赖做种者在线", "冷门种子速度较慢", "需要安全软件配合检查"],
    formats: ".torrent 文件，内部登记文件树、哈希与追踪服务器信息",
  },
  {
    id: "aliyun",
    name: "阿里云盘",
    icon: "ri-hard-drive-3-line",
    usage: "把分享内容保存到云盘后在线播放，或按需下载到本地设备长期保存。",
    pros: ["上传下载速度体验较好", "在线播放较为流畅", "界面清爽，操作门槛低"],
    cons: ["分享限制随平台策略调整", "外部分享链接有时需要登录", "热门资源容易被集中清理"],
    formats: "在线播放流、离线下载文件、压缩包与字幕文件",
  },
];

export const querySteps = [
  {
    step: "01",
    title: "确定准确标题",
    desc: "先用完整片名「善良的女秘书」进行检索，必要时补充年份、地区或别名，减少同名内容干扰。",
    tips: ["优先使用完整标题", "可尝试加年份或地区限定"],
  },
  {
    step: "02",
    title: "选择查询渠道",
    desc: "按习惯在百度云、网盘聚合页、磁力链接或阿里云盘之间选择，先看哪个渠道条目更全、更新时间更新。",
    tips: ["多渠道横向比较", "关注条目的更新时间"],
  },
  {
    step: "03",
    title: "核对条目信息",
    desc: "确认标题、文件大小、清晰度、语言与字幕是否与需求一致，避免下载到无关或重复的内容。",
    tips: ["核对大小与清晰度", "确认语言与字幕信息"],
  },
  {
    step: "04",
    title: "安全保存使用",
    desc: "转存或下载后先做安全扫描，解压前确认文件类型，仅保留内容合法的文件并注意个人隐私保护。",
    tips: ["先查毒再解压", "留意捆绑与广告程序"],
  },
];

export const tools = [
  {
    name: "迅雷",
    icon: "ri-download-cloud-2-line",
    type: "下载工具",
    core: "磁力与种子的加速下载",
    formats: "magnet / .torrent / http",
    member: "部分加速功能需会员",
    fit: "追求下载稳定性",
  },
  {
    name: "百度网盘",
    icon: "ri-cloud-line",
    type: "网盘客户端",
    core: "转存、在线播放与离线下载",
    formats: "分享链接 / 离线文件",
    member: "提速与容量需会员",
    fit: "习惯网盘整理",
  },
  {
    name: "阿里云盘",
    icon: "ri-hard-drive-3-line",
    type: "网盘客户端",
    core: "云盘保存与在线播放",
    formats: "分享链接 / 离线文件",
    member: "部分权限需会员",
    fit: "看重传输速度",
  },
  {
    name: "qBittorrent",
    icon: "ri-seedling-line",
    type: "BT 客户端",
    core: "纯净的种子与磁力下载",
    formats: "magnet / .torrent",
    member: "免费开源",
    fit: "偏好无广告环境",
  },
  {
    name: "比特彗星",
    icon: "ri-planet-line",
    type: "BT 客户端",
    core: "种子上传下载与做种",
    formats: "magnet / .torrent",
    member: "基础功能免费",
    fit: "需要做种与端口设置",
  },
];

export const safetyTips = [
  {
    icon: "ri-shield-check-line",
    title: "优先核对来源合法性",
    desc: "在保存或下载前，先确认内容是否有正规发行渠道与授权，优先选择合法的观看方式。",
  },
  {
    icon: "ri-virus-line",
    title: "下载后先做安全扫描",
    desc: "压缩包与可执行文件是风险高发区，解压前用安全软件扫描，避免运行来源不明的 .exe 文件。",
  },
  {
    icon: "ri-eye-off-line",
    title: "不要在陌生站点登录账号",
    desc: "部分跳转页面会伪装成网盘登录页，切勿在这些页面输入账号密码或短信验证码。",
  },
  {
    icon: "ri-advertisement-line",
    title: "留意捆绑与广告程序",
    desc: "安装下载工具时选择自定义安装，取消默认勾选的附加软件与浏览器插件。",
  },
  {
    icon: "ri-time-line",
    title: "接受链接会失效的现实",
    desc: "网盘分享具有时效性，打不开属常见情况，不必反复提交个人信息来「解锁」。",
  },
  {
    icon: "ri-shield-user-line",
    title: "保护个人隐私",
    desc: "不向陌生站点提供手机号、身份证或支付信息，避免被用于推销与诈骗。",
  },
];

export const faqs = [
  {
    q: "「善良的女秘书」在这些渠道里一般是怎么被找到的？",
    a: "常见的做法是先用完整片名检索，再分别到网盘聚合页、百度云、阿里云盘以及磁力链接 / 种子等渠道查看条目。不同渠道的收录情况不一样，横向比较能更快判断哪个来源更新、信息更完整。",
  },
  {
    q: "为什么网盘分享链接经常打不开？",
    a: "网盘分享会因平台规则调整、发布者主动取消或时间过久而失效，这是很正常的现象。遇到失效时，建议换一个关键词或换一个渠道重新查找，而不是在陌生页面输入个人信息。",
  },
  {
    q: "磁力链接和种子资源有什么区别？",
    a: "两者属于同一套分发体系。种子是 .torrent 文件，包含完整的分块与校验信息；磁力链接是一串以 magnet:? 开头的文本，通过内容哈希定位资源。磁力链接更便于传播，种子信息更完整，两者在多数客户端中可以互相转换。",
  },
  {
    q: "百度云和阿里云盘应该优先用哪个？",
    a: "取决于你的使用习惯。百度云收录面普遍更广、更容易命中标题，但非会员下载速度可能受限；阿里云盘在传输与在线播放体验上通常更顺滑。可以先都看一眼，再选择条目更合适的那一个。",
  },
  {
    q: "迅雷一定要开通会员吗？",
    a: "基础下载功能无需会员即可使用，部分加速、离线空间等增强功能才需要会员。对资源热度较高的内容，普通下载通常也能满足需求。",
  },
  {
    q: "下载下来的压缩包要怎么处理？",
    a: "先做安全扫描再解压，解压时留意是否需要专用工具。若发现文件是可执行程序或来源不明，建议直接删除，不要运行。",
  },
  {
    q: "在手机上能找到并观看吗？",
    a: "可以。网盘类渠道通常支持手机浏览器与 App，先转存再在线播放是最省事的方式；磁力与种子类内容则需要在手机上安装支持相应协议的客户端。",
  },
  {
    q: "这个页面会提供直接的下载地址吗？",
    a: "不会。本站只整理查询思路、渠道科普与注意事项，用于帮助你理解各个渠道的差别，并不托管、也不提供任何受版权保护的作品文件。请通过合法渠道获取内容。",
  },
];

export const relatedTags = [
  "善良的女秘书百度云",
  "善良的女秘书网盘资源",
  "善良的女秘书迅雷下载",
  "善良的女秘书磁力链接",
  "善良的女秘书种子资源",
  "善良的女秘书阿里云盘",
  "网盘分享链接",
  "磁力链接用法",
  "种子文件说明",
  "离线下载",
  "在线播放",
  "网盘转存",
];

export const searchSuggestions = [
  {
    keyword: "善良的女秘书百度云",
    channel: "百度云",
    desc: "在网盘内检索转存，适合习惯在线观看、想长期整理到个人空间的用户。",
  },
  {
    keyword: "善良的女秘书网盘资源",
    channel: "网盘聚合",
    desc: "先看聚合页的条目列表，比较多个网盘入口的更新时间与文件信息。",
  },
  {
    keyword: "善良的女秘书迅雷下载",
    channel: "迅雷",
    desc: "把磁力链接或种子交给迅雷加速，适合对下载稳定性有要求的用户。",
  },
  {
    keyword: "善良的女秘书磁力链接",
    channel: "磁力",
    desc: "复制 magnet 链接到支持磁力的客户端解析，传播方便但不显示文件列表。",
  },
  {
    keyword: "善良的女秘书种子资源",
    channel: "种子",
    desc: "下载 .torrent 文件后选择性下载，包含完整的分块与校验信息。",
  },
  {
    keyword: "善良的女秘书阿里云盘",
    channel: "阿里云盘",
    desc: "部分分享会转存到阿里云盘发布，更看重传输速度与在线播放体验可优先看这里。",
  },
  {
    keyword: "网盘分享链接",
    channel: "通用",
    desc: "分享链接具有时效性，失效后换关键词或换渠道重新检索即可，不必提交个人信息。",
  },
  {
    keyword: "磁力链接用法",
    channel: "磁力",
    desc: "以 magnet:?xt=urn:btih: 开头的一整段文本，需要完整复制才能正常解析。",
  },
  {
    keyword: "种子文件说明",
    channel: "种子",
    desc: ".torrent 文件登记了文件树、哈希与追踪服务器信息，是 BT 分发的基础文件。",
  },
  {
    keyword: "离线下载",
    channel: "网盘",
    desc: "由网盘服务器代替你完成下载，完成后转存到个人空间，省去长时间挂机。",
  },
  {
    keyword: "在线播放",
    channel: "网盘",
    desc: "网盘类渠道通常支持边看边加载，适合移动端直接观看，无需先下载到本地。",
  },
  {
    keyword: "网盘转存",
    channel: "网盘",
    desc: "把他人分享的内容保存到自己的网盘空间，便于后续管理、分类与分享。",
  },
];

export const updates = [
  {
    date: "2026-10-06",
    tag: "提示",
    title: "补充了网盘链接失效后的处理建议",
    desc: "在查询步骤与常见问题中增加了链接失效的应对说明，提醒不要向陌生页面提交个人信息。",
  },
  {
    date: "2026-09-28",
    tag: "工具",
    title: "更新了下载工具对比表",
    desc: "新增 qBittorrent 与比特彗星的对比维度，便于在迅雷与网盘之外选择合适的客户端。",
  },
  {
    date: "2026-09-15",
    tag: "渠道",
    title: "梳理了六大渠道的适用场景",
    desc: "为百度云、网盘资源、迅雷下载、磁力链接、种子资源与阿里云盘补齐了适用人群与常见文件格式。",
  },
  {
    date: "2026-09-02",
    tag: "安全",
    title: "完善了安全与合规提示",
    desc: "围绕来源合法性、查毒解压与隐私保护三条主线，整理了六条可执行的注意事项。",
  },
  {
    date: "2026-08-20",
    tag: "内容",
    title: "整理常见问题解答",
    desc: "把分散的疑问归纳为八条问答，覆盖渠道差异、链接失效、压缩包处理与移动端使用。",
  },
];